export const SHARED_PATIENT_ASSISTANCE_BUSINESS_FLOW_CASE_INITIAL_STATE = 'Initial';
